/**
 * User: nir
 * Date: 26/07/2016
 * Time: 15:31
 */

var trackCTA = function (eventName, label) {
    label = label || null;
    ga('send', 'event', 'CTA', eventName, label, {
        'hitCallback': function () {
        }
    });
    dataLayer.push({'eventCategory': 'CTA', 'event': eventName, 'eventLabel': label});
    return true;
};

var trackCTANoInteraction = function (eventName, label) {
    ga('send', 'event', 'Non Interaction', eventName, document.title, {
        nonInteraction: true
    });

    dataLayer.push({'eventCategory': 'Non Interaction', nonInteraction: true, 'event': eventName, 'eventLabel': label});
};

var trackConversion = function (eventName, url, label) {
    ga('send', 'event', 'Conversion', eventName, url);
    dataLayer.push({'eventCategory': 'Conversion', 'event': eventName, 'eventLabel': label});
};

var trackTest = function (eventName, label) {
    dataLayer.push({'eventCategory': 'Test', 'event': eventName, 'eventLabel': label});
};

window.TCT = window.TCT || {};
window.TCT.hasTracking = true;